interface ToastOptions {
  allowMultiple?: boolean;
  maxItems?: number;
  timeout?: number;
  position?: string;
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
}

enum AlertType {
  Success = 'success',
  Error = 'error',
  Information = 'information',
  Warning = 'warning',
  SuccessBold = 'success-bold',
  ErrorBold = 'error-bold',
}

interface CgAlert {
  type: AlertType,
  backgroundColor?: string | null,
  hideIcon: boolean,
}

interface ToastItem extends CgAlert {
  message: string;
  id: number | string;
  timeout?: number;
  html: boolean;
}

interface ToastItemOptions {
  hideIcon?: boolean;
  html?: boolean;
}

export {
  ToastItem,
  AlertType,
  ToastOptions,
  ToastItemOptions,
}

declare module 'vue/types/vue' {
  export interface Vue {
    $cgToast: ReturnType<typeof Object>;
  }

  export interface VueConstructor {
    $cgToast: ReturnType<typeof Object>;
  }
}
